import apiClient, { type PagedResponse } from '../client'
import type { UsuarioResponse, RoleResponse } from '../models/response'
import type { UpdateUsuarioRequest } from '../models/request'

const BASE_PATH = '/usuarios'

export const usuariosService = {
  async getAll(params?: {
    page?: number
    pageSize?: number
    search?: string
  }): Promise<PagedResponse<UsuarioResponse>> {
    return apiClient.get<PagedResponse<UsuarioResponse>>(BASE_PATH, params)
  },

  async getById(id: string): Promise<UsuarioResponse> {
    return apiClient.get<UsuarioResponse>(`${BASE_PATH}/${id}`)
  },

  async update(id: string, data: UpdateUsuarioRequest): Promise<UsuarioResponse> {
    return apiClient.put<UsuarioResponse, UpdateUsuarioRequest>(`${BASE_PATH}/${id}`, data)
  },

  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(`${BASE_PATH}/${id}`)
  },

  async getRoles(): Promise<RoleResponse[]> {
    return apiClient.get<RoleResponse[]>(`${BASE_PATH}/roles`)
  },
}
